<template lang="html">
    <form @submit.prevent="store">
        <form-user :user="user" :errors="errors" :create-form="true"></form-user>
        <div class="columns">
            <div class="column">
                <div class="block">
                    <div class="field is-grouped">
                        <p class="control">
                            <button class="button is-success" type="submit">Guardar</button>

                        </p>
                        <p class="control">
                            <button class="button" type="reset" @click="cancel">Cancelar</button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    export default {
        data() {
            return {
                loading: false,
                errors: {},
                user: {
                    email: '',
                    profile: {
                        name: '',
                        last_name: '',
                        other_name: '',
                        role: '',
                        birthday: new Date(),
                    },
                    password: '',
                    password_confirmation: '',
                },
            }
        },
        props: {},
        beforeRouteEnter(to, from, next) {
            next(vm => vm.prepareComponent())
        },
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent() {

                this.$root.preloader = false;
            },
            store() {

                var userData = [{
                    "name": this.user.profile.name,
                    "last_name": this.user.profile.last_name,
                    "other_name": this.user.profile.other_name,
                    "email": this.user.email,
                    "password": this.user.password,
                    "password_confirmation": this.user.password_confirmation,
                    "role": this.user.role,
                    "birthday": this.user.profile.birthday,
                    "gender": this.user.profile.gender,
                    'personal_phone': this.user.personal_phone,
                    'extension': this.user.extension,
                    'provider': this.user.provider
                }];

                this.errors = {};
                this.$loader.show();
                this.$http.post('/user', userData[0]).then(({data}) => {
                    this.$loader.hide();
                    this.$notify.success(data);
                    this.$router.push('/admin/users');
                    //this.$router.push({name:'users'});
                }, ({response}) => {
                    this.$loader.hide();
                    let data = response.data || {};
                    this.errors = data.errors || {}
                })


            },
            cancel() {
                this.$emit('cancel');
                //this.$router.push('/user');
                this.$router.back();
            },
        }
    }
</script>

<style lang="css">
</style>
